
import product from '../../../common/mixins/products/product'
import redirectWeb from '../../../common/mixins/redirectWeb'
import Deal from './Deal'
import Pizza from './Pizza'
import HalfNHalf from './HalfNHalf'

export default {
  name: 'ProductCustomizer',
  components: {
    Deal,
    Pizza,
    HalfNHalf
  },
  mixins: [product, redirectWeb]
}
